export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

export const ENABLE_REDUX_DEV_TOOLS = () => {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }
  return true;
};

export const orgId = process.env.REACT_APP_ORG_ID;

export const phoneRegExp = /^\+(?:[ 0-9] ?){10,14}[0-9]$/;
export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
